import { AccountObjectFacade } from "../account-object/account-object.facade";
import { CategoryApiFacade } from "./category.api-facade";
import { CategoryStoreFacade } from "./category.store-facade";
import { Category } from "./category.model";

export abstract class CategoryFacade<T extends Category, A extends CategoryApiFacade<T>, S extends CategoryStoreFacade<T>> extends AccountObjectFacade<T, A, S> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/category/category.facade.ts